// app/javascript/controllers/read_receipts_controller.js
import { Controller } from "@hotwired/stimulus"
import consumer from "./../channels/consumer"
export default class extends Controller {
    static targets = ["message"]
    static values = {
        currentUserId: Number,
        watermark: Number,
        conversationId: Number,
        readWatermarkFallbackUrl: String       // Still used if the WebSocket fails
    }

    connect() {
        this.highestPendingId = this.watermarkValue
        this.debounceTimeout = null
        // 1. Establish the custom bi-directional ActionCable channel
        this.channel = consumer.subscriptions.create(
            { channel: "ConversationChannel", conversation_id: this.conversationIdValue },
            {
                connected: () => {
                    console.log("Connected to ActionCable channel");
                    this.checkInitialVisibleMessages();
                    this.isSocketConnected = true },
                disconnected: () => {
                    console.log("disconnected to ActionCable channel")
                    this.isSocketConnected = false
                },
                rejected: () => {
                    console.log("rejected to ActionCable channel")
                    this.isSocketConnected = false
                },
                received: (data) => { this.handleServerBroadcast(data) }
            }
        )

        this.observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) this.processIntersection(entry.target)
            })
        }, { threshold: 0.2 })
    }

    disconnect() {
        if (this.observer) this.observer.disconnect()
        if (this.debounceTimeout) clearTimeout(this.debounceTimeout)
        if (this.channel) this.channel.unsubscribe()
    }

    messageTargetConnected(element) {
        console.log("messageTargetConnected", element)
        console.log("messageTargetConnected", element)
        console.log("messageTargetConnected", element)
       //# if (Number(element.dataset.senderId) === this.currentUserIdValue) return
      // # if (Number(element.dataset.id) <= this.watermarkValue) return
        if (this.observer){
            this.observer.observe(element)
        }

    }

    processIntersection(element) {
        const msgId = Number(element.dataset.id)
        console.log("processIntersection", element)
        if (msgId > this.highestPendingId) {
            this.highestPendingId = msgId
            this.queueWatermarkSync()
        }
        this.observer.unobserve(element)
    }

    queueWatermarkSync() {
        if (this.debounceTimeout) clearTimeout(this.debounceTimeout)
        this.debounceTimeout = setTimeout(() => this.syncWatermark(), 1500)
    }
    // Scans elements once the WebSocket is fully initialized and open
    checkInitialVisibleMessages() {
        this.messageTargets.forEach(el => {
            // Begin observing existing unread targets now that the observer is alive
            this.messageTargetConnected(el)

            // Check if it's already in the viewport right now
            const rect = el.getBoundingClientRect()
            const inView = rect.top >= 0 && rect.bottom <= window.innerHeight
            if (inView && Number(el.dataset.senderId) !== this.currentUserIdValue) {
                this.processIntersection(el)
            }
        })
    }
    syncWatermark() {
        if (this.highestPendingId <= this.watermarkValue) return
        const targetId = this.highestPendingId
        // 2. Primary Route: Try sending via raw WebSocket frame
        if (this.isSocketConnected) {
            try {
                console.log("Sending watermark update via WebSocket...")
                this.channel.perform("update_watermark", { max_message_id: targetId })
                this.watermarkValue = targetId // Optimistic update
                return
            } catch (e) {
                console.warn("WebSocket send failed, falling back to HTTP...", e)
            }
        }

        // 3. Fallback Route: Fall back to standard HTTP POST if socket is dead
        this.syncViaHttp(targetId)
    }

    async syncViaHttp(targetId) {
        console.log("Sending watermark update via syncViaHttp...")
        try {
            const response = await fetch(this.readWatermarkFallbackUrlValue, {
                method: "POST",
                headers: { "X-CSRF-Token": this.csrf(), "Content-Type": "application/json" },
                body: JSON.stringify({ max_message_id: targetId })
            })
            if (response.ok) this.watermarkValue = targetId
        } catch (error) {
            console.error("Critical: Both WebSocket and HTTP sync failed", error)
        }
    }

    handleServerBroadcast(data) {
        if (data.event === "watermark_updated") {
            // Handle updating visual read checkmarks on the screen UI
            // dynamically when other participants move their watermarks down.
            console.log(`User ${data.user_id} read up to message ${data.max_message_id}`)
        }
    }

    csrf() { return document.querySelector("meta[name='csrf-token']").getAttribute("content") }
}
